const MATCH_WHITE_SPACES = /\s{2,}/g;

export const wrapWhiteSpaces = (string) => string.replace(MATCH_WHITE_SPACES, ' ');
